import Shepherd from 'shepherd.js';

export default {
    install(app) {
        app.config.globalProperties.shepherd = (...args) => {
            return new Shepherd.Tour(...args);
        };
        app.provide('shepherd', app.config.globalProperties.shepherd)
    }
};